import { Action } from '@ngrx/store';
import { MfaInterface } from '../../models/mfa.interface';

export enum EMissionActions {
  SaveMission = '[MISSION] Save mission',
  UpdateMission = '[MISSION] Update mission',
  SaveMissionSuccess = '[MISSION] Save mission success',
  SaveMissionFailure = '[MISSION] Save mission failure'
}

export class UpdateMission implements Action {
  public readonly type = EMissionActions.UpdateMission;
  constructor(public payload: any, public procedureCode: string, public mfa: MfaInterface|null = null) {}
}

export class SaveMission implements Action {
  public readonly type = EMissionActions.SaveMission;
  constructor(public payload: any, public procedureCode: string, public mfa: MfaInterface|null = null) {}
}

export class SaveMissionSuccess implements Action {
  public readonly type = EMissionActions.SaveMissionSuccess;
  constructor(public payload: any) {}
}

export class SaveMissionFailure implements Action {
  public readonly type = EMissionActions.SaveMissionFailure;
}

export type SaveMissionActions = SaveMission | UpdateMission | SaveMissionSuccess | SaveMissionFailure;
